if (!customElements.get('liene-faq-expandable')) {
  customElements.define('liene-faq-expandable', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.items = [...this.querySelectorAll('.lfq__item')];
      this.button = this.querySelector('.lfq__more');
      if (!this.button) return;
      this.limit = Math.max(1, Number.parseInt(this.dataset.visible, 10) || 4);
      this.expanded = false;
      this.setExpanded = expanded => {
        this.expanded = expanded;
        this.items.forEach((item, index) => {
          item.hidden = !expanded && index >= this.limit;
        });
        this.button.hidden = this.items.length <= this.limit;
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.querySelector('[data-more]').hidden = expanded;
        this.button.querySelector('[data-less]').hidden = !expanded;
      };
      this.button.addEventListener('click', () => {
        const collapsing = this.expanded;
        this.setExpanded(!this.expanded);
        // Keep the focused control in view after the page becomes shorter.
        if (collapsing) {
          const rect = this.button.getBoundingClientRect();
          if (rect.top < 0 || rect.bottom > window.innerHeight) {
            this.button.scrollIntoView({ block: 'nearest', behavior: 'instant' });
          }
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.lfq__item');
        if (!item || !this.items.includes(item)) return;
        if (item.hidden) this.setExpanded(true);
        item.open = true;
      }, options);
      this.setExpanded(false);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
